import { buildUrl } from '@repo/toolkit/build-url'
import { useNavigator } from '@repo/toolkit/use-navigator'
import { BusIcon } from '@repo/ui/icons'
import { useMutation, useQuery } from '@tanstack/react-query'
import { useLocation, useParams } from 'react-router-dom'
import { toast } from 'sonner'

import { createCoachCompany } from '../../../../api/ols/coach-companies/create-coach-companies'
import { getOl } from '../../../../api/ols/get-ol'
import { Paths } from '../../../../lib/constants/path'
import useTranslate from '../../../../lib/hooks/use-translate'
import { twoButtonsConfig } from '../../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../../lib/utils/functions/misc.functions'
import { constructOlPath } from '../../../../views/ols/views/utils'
import { ItemNotFound } from '../../../elements/item-not-found'
import UserNavBar from '../../../elements/nav-bar'
import CoachCompanyForm from './coach-company-form'

export function OlCoachCompanyCreatePage() {
  const { navigate, back } = useNavigator()
  const location = useLocation()
  const { t } = useTranslate()
  const { olId } = useParams<{ olId: string }>()

  const { data: ol } = useQuery({
    queryKey: ['ol', olId],
    queryFn: () => getOl(Number(olId)),
    enabled: !!olId && !isNaN(Number(olId))
  })

  const { mutateAsync } = useMutation({
    mutationFn: createCoachCompany,
    onError: showAxiosError,
    onSuccess: (data) => {
      if (!ol) return
      navigate(buildUrl(Paths.OL_COACH_COMPANIES_VIEW_PAGE, { id: data.id, olId: ol.id }), {
        replace: true,
        state: { from: (location.state as { from?: string } | null)?.from }
      })
      toast.success(t('coach.company.created.successfully'))
    }
  })

  if (!ol) return <ItemNotFound title="OL not found" />

  return (
    <div>
      <UserNavBar
        title={'Ajouter une compagnie de bus'}
        icon={(props) => <BusIcon filled {...props} />}
      />
      <div className={'h-4'} />
      <CoachCompanyForm
        country={ol.country ?? 'FR'}
        buttonsConfig={twoButtonsConfig({
          onCancel: () => back(constructOlPath(Paths.OL_COACH_COMPANIES_LIST_PAGE, ol.id)),
          onConfirm: async (values) => await mutateAsync({ ...values, olId: ol.id })
        })}
      />
    </div>
  )
}
